import React from "react";
import PropTypes from "prop-types";
import useAboveBreakpoint from "core-web/hooks/useAboveBreakpoint";
import { mediaQueryProp } from "core-web/utils/proptypes/modules/mediaProps";
import Image from "core-web/components/Image";
import Link from "core-web/components/Link";
import styled from "theme/libs/styled";
import activeSetting from "theme/libs/wordpress/utils/activeSetting";

const Wrapper = styled("div")`
    overflow: hidden;
    height: 100%;
    margin-top: 80px;

    &[data-hover="true"] {
        transition: transform ${({ theme }) => theme.transitions.primarySlow};

        ${({ theme }) => theme.media.hover} {
            &:hover {
                transform: scale(1.05);
            }
        }
    }

    &[data-fullscreen="true"] {
        border-radius: 0;
    }
`;

const ImageBlock = ({ content, isFirstModule, loading, mediaQuery, hasHover, isFullscreen, ...rest }) => {
    const moduleContent = content?.data ?? content;
    const { settings = [], link, background_image: bgImage } = moduleContent || {};
    const desktopImg = bgImage?.desktop_background_image?.image || bgImage?.mobile_background_image?.image;
    const mobileImg = bgImage?.mobile_background_image?.image || bgImage?.desktop_background_image?.image;

    // eslint-disable-next-line array-bracket-spacing
    const mediaQueries = [576, 506, 744, 594, 990, 1287];

    const wrapperLink = activeSetting(settings, "link") && link;

    const isAboveMd = useAboveBreakpoint("tabletSm");
    const image = isAboveMd ? desktopImg : mobileImg;

    if (image?.url) {
        return null;
    }

    return (
        <Wrapper data-hover={hasHover} data-fullscreen={isFullscreen} {...rest}>
            <Link to={wrapperLink}>
                <Image
                    loading={isFirstModule ? "eager" : loading}
                    objectFit="cover"
                    alt={image?.meta?.name || image?.title}
                    title={image?.meta?.name || image?.title}
                    borderRadius="12px"
                    src={{
                        url: image?.url,
                        width: mediaQuery?.w || mediaQueries,
                        q: mediaQuery?.q || 70,
                    }}
                />
            </Link>
        </Wrapper>
    );
};

ImageBlock.propTypes = {
    content: PropTypes.object,
    hasHover: PropTypes.bool,
    isFirstModule: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    loading: PropTypes.string,
    mediaQuery: mediaQueryProp,
    withBorderRadius: PropTypes.bool,
};

ImageBlock.defaultProps = {
    hasHover: false,
    isFirstModule: false,
    isFullscreen: false,
    loading: "lazy",
    mediaQuery: undefined,
    withBorderRadius: false,
};

export default ImageBlock;
